/**
 * ContentLayoutToggle — bascule centered ⇄ stretched depuis le UI, en un
 * seul clic, sans passer par Réglages.
 *
 * @remarks
 * Lit/écrit `useUIPrefsStore.contentLayout`. Même pattern que `ThemeToggle` :
 * toggle binaire, l'icône affichée est celle du mode vers lequel on bascule.
 *
 * **Note d'archi** : comme `ThemeToggle`, on accepte ici qu'un composant de
 * `shared/components/` lise un store de `app/stores/` — tolérable car le
 * store est global et partagé, pas propre à une feature.
 */

import { AlignHorizontalJustifyCenter, StretchHorizontal } from 'lucide-react';
import { useUIPrefsStore } from '@/app/stores/use-ui-prefs-store';
import { IconButton } from '@/shared/ui';

export function ContentLayoutToggle() {
  const contentLayout = useUIPrefsStore((s) => s.contentLayout);
  const setContentLayout = useUIPrefsStore((s) => s.setContentLayout);

  const isStretched = contentLayout === 'stretched';

  const toggle = () => {
    setContentLayout(isStretched ? 'centered' : 'stretched');
  };

  const Icon = isStretched ? AlignHorizontalJustifyCenter : StretchHorizontal;
  const label = isStretched ? 'Centrer le contenu' : 'Étirer le contenu';

  return (
    <IconButton aria-label={label} title={label} onClick={toggle} size="sm">
      <Icon className="size-4" aria-hidden />
    </IconButton>
  );
}
